import { CustomerResponse, Menu } from '@/store/customer';
import { customerStore } from '@/store';
import { useState, useEffect } from 'react';
import type { MenuProps } from 'antd';
import { unstable_batchedUpdates } from 'react-dom';
import { IconFont } from '@/components';
import { getTokenMerge } from '@/utils/ways';
import eventLib from 'src/common/document-event/index';
import { componentDocsMenu } from '@/layout/componentMenuConfig';

const { getInfo, getModule } = customerStore;


function dealWithMenu<T extends Menu> (list: T[] = [], map: Map<string, string>, parentUri?: string | null) {
  if (Array.isArray(list) && list.length) {
    return list.map((item) => {
      const { name, uri, icon, children, parent, encode, path } = item;
      if (parent && parentUri) {
        map.set(uri || path || '', parentUri! || encode!);
      }
      return {
        label: name,
        key: uri || path || encode,
        icon: icon && <IconFont iconHref={icon} />,
        children: dealWithMenu(children, map, uri || path || encode),
      };
    });
  } else {
    return null;
  }
};

function useCustomerInfo(): [MenuProps['items'], Omit<CustomerResponse, 'moduleList'>, Map<string, string>] {
  const [info, setInfo] = useState<Omit<CustomerResponse, 'moduleList'>>({});
  const [items, setItems] = useState<MenuProps['items']>([]);
  const [openKeysMap, setOpenKeysMap] = useState<Map<string, string>>(new Map());
  const [shouldRefresh, setShouldRefresh] = useState<number>(0); // 仅用于触发更新数据
  const token = getTokenMerge();

  const getCustomerInfo = async () => {
    try {
      const { ...restResult } = await getInfo();
      const moduleList:any = await getModule();

      // 如果是开发环境或者集成环境下，则显示组件demo菜单
      if (process.env.NODE_ENV === 'development' || process.env.NODE_TYPE === 'ie') { moduleList.push({ id: 9999999999, name: '组件demo', children: componentDocsMenu }); }

      unstable_batchedUpdates(() => {
        setInfo(restResult);

        const menu = JSON.parse(JSON.stringify(moduleList).replace(/\/lhb-micro-pms/g, ''));
        const menusItems = dealWithMenu(menu, openKeysMap);
        setOpenKeysMap(new Map(openKeysMap));
        setItems(menusItems);
      });

    } catch (e) {
      // dispatchNavigate('/404');
      setItems([]);
    }
  };

  useEffect(() => {
    if (!token) {
      return;
    }
    getCustomerInfo();
  }, [token, shouldRefresh]);

  useEffect(() => {
    // 切换租户的时候需要重新获取userInfo
    eventLib.on('LOADING', () => {
      setShouldRefresh(+new Date());
    });
  }, []);

  return [items, info, openKeysMap];
}

export default useCustomerInfo;
